/**
 * aerobis cart-drawer free-shipping top-up for the EUR 200 gate only.
 * Persistent asset: Impact AJAX drawer HTML does not run inline scripts.
 * One paid 1-tap line under the free-ship bar. Not a gift.
 * Does not change gates, rates, US/CA prices, the estimator, or GWP tiers.
 * Pusher Add-on and Swivel Mount are never offered.
 *
 * Gap and prices are compared in shop EUR (presentment cents / Shopify.currency.rate),
 * the same conversion free-ship-line.js uses. The line copy has no amount.
 * The existing bar already shows the remaining amount in presentment currency.
 */
(function () {
  if (window.aerobisFreeShipTopup) return;

  var GATE_EUR = 200;
  var GAP_MAX_EUR = 70;
  var MIN_PRICE_EUR = 25;

  var SLING_HANDLES = {
    "aerosling-elite-our-original-slingtrainer": true,
    "aerosling-tactical-full-black-high-end-slingtrainer": true
  };
  var POWR_HANDLES = {
    "powrlink-measure-your-complete-fitness": true,
    "powrlink-light-measure-fitness-up-to-600-kg": true,
    "powrlink-light-grip-strength-set": true,
    "powrlink-grip-strength-set": true,
    "powrlink-3-measure-strength-up-to-600-kg": true,
    "powrlink-3-kraftmessgeraet-bis-600-kg": true
  };
  var TRAINER_HANDLES = {
    "powerband-trainer-200kg-of-resistance": true
  };

  var OFFERS = {
    sling: [
      "flex-handle-xl-large-padded-loop",
      "powerspring-for-slingtrainers"
    ],
    powrlink: [
      "powrlink-grip-strength-frame"
    ],
    powerband: [
      "aerobis-rowstick-new-version-of-our-versatile-fitness-core-stick"
    ],
    fallback: [
      "sleep-mask-100-blackout-memory-foam"
    ]
  };

  var DENY = {
    "powrlink-light-pusher-add-on": true,
    "aerobis-swivel-mount": true
  };

  var productCache = {};
  var seq = 0;
  var refreshTimer = null;

  function norm(value) {
    return String(value == null ? "" : value).trim().toLowerCase();
  }

  function tagsOf(item) {
    var tags = item && (item.tags || item.product_tags) || [];
    if (typeof tags === "string") tags = tags.split(",");
    var out = [];
    for (var i = 0; i < tags.length; i++) {
      var tag = norm(tags[i]);
      if (tag) out.push(tag);
    }
    return out;
  }

  function classifyItem(item) {
    var handle = norm(item && item.handle);
    var type = norm(item && (item.product_type || item.type));
    var tags = tagsOf(item);
    var kinds = [];
    if (SLING_HANDLES[handle] || type === "sling trainers" || tags.indexOf("1. sling trainers") !== -1) {
      kinds.push("sling");
    }
    if (POWR_HANDLES[handle] || type === "measure fitness with sensors") {
      kinds.push("powrlink");
    }
    if (TRAINER_HANDLES[handle] || handle.indexOf("powerband-trainer") === 0) {
      kinds.push("powerband");
    }
    return kinds;
  }

  function candidateHandles(items) {
    var seenKind = {};
    var kinds = [];
    var list = items || [];
    for (var i = 0; i < list.length; i++) {
      var kindsForItem = classifyItem(list[i]);
      for (var k = 0; k < kindsForItem.length; k++) {
        if (!seenKind[kindsForItem[k]]) {
          seenKind[kindsForItem[k]] = true;
          kinds.push(kindsForItem[k]);
        }
      }
    }
    var seen = {};
    var handles = [];
    function add(handle) {
      if (!handle || seen[handle] || DENY[handle]) return;
      seen[handle] = true;
      handles.push(handle);
    }
    var source = kinds.length ? kinds : ["fallback"];
    for (var s = 0; s < source.length; s++) {
      var group = OFFERS[source[s]] || [];
      for (var h = 0; h < group.length; h++) add(group[h]);
    }
    return handles;
  }

  function inCartHandles(items) {
    var set = {};
    var list = items || [];
    for (var i = 0; i < list.length; i++) {
      var handle = norm(list[i] && list[i].handle);
      if (handle) set[handle] = true;
    }
    return set;
  }

  function shopEur(cents, rate) {
    var n = Number(cents);
    if (!isFinite(n) || !(rate > 0)) return null;
    return n / 100 / rate;
  }

  function oneTapVariant(product) {
    if (!product || product.available === false) return null;
    if (product.requires_selling_plan) return null;
    if (product.selling_plan_groups && product.selling_plan_groups.length) return null;
    var variants = product.variants || [];
    var ok = [];
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      if (!variant || variant.available === false || variant.requires_selling_plan) continue;
      ok.push(variant);
    }
    if (ok.length !== 1) return null;
    return ok[0];
  }

  function pickOffer(opts) {
    opts = opts || {};
    var gate = Number(opts.gateEur);
    var rate = Number(opts.rate);
    if (!(Math.abs(gate - GATE_EUR) < 1e-6)) return null;
    if (!(rate > 0)) return null;
    var cartCents = Number(opts.cartCents);
    if (!isFinite(cartCents)) cartCents = 0;
    var gap = gate - cartCents / 100 / rate;
    if (!(gap > 1e-6) || gap > GAP_MAX_EUR + 1e-6) return null;

    var items = opts.items || [];
    var handles = candidateHandles(items);
    var incart = inCartHandles(items);
    var products = opts.products || {};
    var best = null;
    var bestPrice = Infinity;
    var bestIndex = Infinity;

    for (var i = 0; i < handles.length; i++) {
      var handle = handles[i];
      if (DENY[handle] || incart[handle]) continue;
      var product = products[handle];
      if (!product) continue;
      var variant = oneTapVariant(product);
      if (!variant) continue;
      var price = shopEur(variant.price, rate);
      if (price == null) continue;
      if (price + 1e-9 < MIN_PRICE_EUR) continue;
      if (price + 1e-6 < gap) continue;
      if (price < bestPrice - 1e-9 || (Math.abs(price - bestPrice) <= 1e-9 && i < bestIndex)) {
        bestPrice = price;
        bestIndex = i;
        best = {
          handle: handle,
          variantId: variant.id,
          title: product.title || handle,
          priceEur: price
        };
      }
    }
    return best;
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  }

  function resolveRate(currencyHint) {
    var shopifyCur = (window.Shopify && Shopify.currency) || {};
    var rate = parseFloat(shopifyCur.rate);
    var active = shopifyCur.active || "";
    var currency = active || currencyHint || "EUR";
    var useRate = rate;
    if (!(useRate > 0)) {
      if (currency === "EUR") useRate = 1;
      else return null;
    }
    if (currency !== "EUR" && useRate === 1) return null;
    return { useRate: useRate, currency: currency };
  }

  function readGate(el) {
    var wrap = el.closest ? el.closest(".free-ship-progress") : null;
    var line = wrap && wrap.querySelector(".free-ship-line");
    return {
      gateEur: line ? parseFloat(line.getAttribute("data-fs-gate-eur") || "0") : 0,
      cartCents: line ? parseInt(line.getAttribute("data-fs-cart-cents") || "0", 10) : 0,
      currency: line ? (line.getAttribute("data-fs-currency") || "") : ""
    };
  }

  function liquidLines(el) {
    var raw = el.getAttribute("data-fst-lines") || "";
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function mergeItems(cartItems, lines) {
    var byHandle = {};
    var liquid = lines || [];
    for (var i = 0; i < liquid.length; i++) {
      if (liquid[i] && liquid[i].handle) byHandle[norm(liquid[i].handle)] = liquid[i];
    }
    var source = cartItems && cartItems.length ? cartItems : liquid;
    var out = [];
    for (var j = 0; j < source.length; j++) {
      var item = source[j] || {};
      var handle = item.handle || "";
      var extra = byHandle[norm(handle)] || {};
      var tags = item.tags && item.tags.length ? item.tags : (extra.tags || []);
      out.push({
        handle: handle,
        product_type: item.product_type || item.type || extra.type || "",
        tags: tags
      });
    }
    return out;
  }

  function paintOffer(el, offer) {
    while (el.firstChild) el.removeChild(el.firstChild);
    if (!offer) {
      el.hidden = true;
      el.removeAttribute("data-fst-handle");
      return;
    }
    var tmpl = el.getAttribute("data-fst-copy") || "Add __PRODUCT__ and your shipping is free";
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "free-ship-topup__btn";
    btn.setAttribute("data-fst-add", String(offer.variantId));
    btn.setAttribute("data-fst-handle", offer.handle);
    var parts = String(tmpl).split("__PRODUCT__");
    btn.appendChild(document.createTextNode(parts[0] || ""));
    var name = document.createElement("span");
    name.className = "free-ship-topup__name";
    name.textContent = offer.title;
    btn.appendChild(name);
    if (parts.length > 1) {
      btn.appendChild(document.createTextNode(parts.slice(1).join("__PRODUCT__")));
    }
    el.appendChild(btn);
    el.hidden = false;
    el.setAttribute("data-fst-handle", offer.handle);
  }

  function fetchProduct(handle) {
    var key = root() + "\n" + handle;
    if (productCache[key]) return Promise.resolve(productCache[key]);
    return fetch(root() + "products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    }).then(function (response) {
      return response.ok ? response.json() : null;
    }).then(function (product) {
      if (product && product.handle) productCache[key] = product;
      return product;
    }).catch(function () {
      return null;
    });
  }

  function paintFromCart(el, cart, my) {
    var ctx = readGate(el);
    var rate = resolveRate(ctx.currency);
    var items = mergeItems(cart && cart.items, liquidLines(el));
    var cents = cart && cart.total_price != null ? cart.total_price : ctx.cartCents;
    if (!rate || !(Math.abs(ctx.gateEur - GATE_EUR) < 1e-6)) {
      paintOffer(el, null);
      return Promise.resolve();
    }
    var gap = ctx.gateEur - (isFinite(Number(cents)) ? Number(cents) : 0) / 100 / rate.useRate;
    if (!(gap > 1e-6) || gap > GAP_MAX_EUR + 1e-6) {
      paintOffer(el, null);
      return Promise.resolve();
    }
    var handles = candidateHandles(items);
    var incart = inCartHandles(items);
    var need = [];
    for (var i = 0; i < handles.length; i++) {
      if (!incart[handles[i]] && !DENY[handles[i]]) need.push(handles[i]);
    }
    if (!need.length) {
      paintOffer(el, null);
      return Promise.resolve();
    }
    return Promise.all(need.map(fetchProduct)).then(function (list) {
      if (my !== seq) return;
      var products = {};
      for (var n = 0; n < need.length; n++) {
        if (list[n]) products[need[n]] = list[n];
      }
      paintOffer(el, pickOffer({
        gateEur: ctx.gateEur,
        cartCents: cents,
        rate: rate.useRate,
        items: items,
        products: products
      }));
    }).catch(function () {
      if (my === seq) paintOffer(el, null);
    });
  }

  function refreshAll() {
    if (!document.querySelector) return;
    var nodes = document.querySelectorAll("[data-free-ship-topup]");
    if (!nodes.length) return;
    var my = ++seq;
    fetch(root() + "cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    }).then(function (response) {
      if (!response.ok) throw new Error("cart");
      return response.json();
    }).then(function (cart) {
      if (my !== seq) return;
      var jobs = [];
      for (var i = 0; i < nodes.length; i++) jobs.push(paintFromCart(nodes[i], cart, my));
      return Promise.all(jobs);
    }).catch(function () {
      if (my !== seq) return;
      for (var i = 0; i < nodes.length; i++) paintOffer(nodes[i], null);
    });
  }

  function scheduleRefresh() {
    refreshAll();
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshAll, 80);
    setTimeout(refreshAll, 400);
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    if (busy) btn.setAttribute("aria-busy", "true");
    else btn.removeAttribute("aria-busy");
  }

  function sectionIdFrom(el) {
    if (!el || !el.id) return "";
    return String(el.id).replace("shopify-section-", "");
  }

  function drawerSectionId() {
    var drawer = document.getElementById("cart-drawer");
    var section = drawer && drawer.closest && drawer.closest(".shopify-section");
    return sectionIdFrom(section);
  }

  function collectSectionIds() {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
      bubbles: true,
      detail: { sections: sections }
    }));
    var drawerId = drawerSectionId();
    if (drawerId && sections.indexOf(drawerId) === -1) sections.push(drawerId);
    return sections;
  }

  function readJson(response) {
    return response.text().then(function (text) {
      var json = {};
      try {
        json = text ? JSON.parse(text) : {};
      } catch (e) {
        json = {};
      }
      if (!response.ok) {
        throw new Error((json && (json.description || json.message)) || "add failed");
      }
      return json;
    });
  }

  function fetchSectionHtml(sectionId) {
    var url = root() + String(window.location.pathname || "").replace(/^\//, "");
    url += (url.indexOf("?") >= 0 ? "&" : "?") + "section_id=" + encodeURIComponent(sectionId);
    return fetch(url, { credentials: "same-origin" })
      .then(function (response) { return response.ok ? response.text() : ""; })
      .catch(function () { return ""; });
  }

  function attachSections(cart, requestedIds, addSections) {
    cart.sections = cart.sections || {};
    if (addSections) {
      Object.keys(addSections).forEach(function (id) {
        if (addSections[id]) cart.sections[id] = addSections[id];
      });
    }
    var missing = (requestedIds || []).filter(function (id) {
      return !cart.sections[id];
    });
    if (!missing.length) return Promise.resolve(cart);
    return Promise.all(missing.map(function (id) {
      return fetchSectionHtml(id).then(function (html) {
        if (html) cart.sections[id] = html;
      });
    })).then(function () { return cart; });
  }

  function publishCart(cart) {
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: { baseEvent: "variant:add", cart: cart }
    }));
  }

  function addVariant(variantId, btn) {
    if (!variantId) return;
    if (btn && btn.getAttribute("aria-busy") === "true") return;
    setBusy(btn, true);
    var sections = collectSectionIds();
    var payload = { id: Number(variantId), quantity: 1 };
    if (sections.length) {
      payload.sections = sections;
      payload.sections_url = window.location.pathname;
    }
    fetch(root() + "cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(payload)
    }).then(readJson).then(function (added) {
      return fetch(root() + "cart.js", {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      }).then(function (response) {
        if (!response.ok) throw new Error("cart failed");
        return response.json();
      }).then(function (cart) {
        return attachSections(cart, sections, added && added.sections);
      });
    }).then(function (cart) {
      publishCart(cart);
      scheduleRefresh();
    }).catch(function () {
      setBusy(btn, false);
    });
  }

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (target && target.nodeType === 3) target = target.parentElement;
    var btn = target && target.closest && target.closest("[data-fst-add]");
    if (!btn) return;
    event.preventDefault();
    addVariant(btn.getAttribute("data-fst-add"), btn);
  });

  document.addEventListener("cart:change", function () { setTimeout(scheduleRefresh, 0); });
  document.addEventListener("cart:refresh", function () { setTimeout(scheduleRefresh, 0); });

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node || node.nodeType !== 1) continue;
          if (
            (node.hasAttribute && node.hasAttribute("data-free-ship-topup")) ||
            (node.querySelector && node.querySelector("[data-free-ship-topup]"))
          ) {
            scheduleRefresh();
            return;
          }
        }
      }
    });
    var startObserver = function () {
      if (document.documentElement) {
        observer.observe(document.documentElement, { childList: true, subtree: true });
      }
    };
    if (document.documentElement) startObserver();
    else document.addEventListener("DOMContentLoaded", startObserver);
  }

  function boot() { scheduleRefresh(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  window.aerobisFreeShipTopup = {
    GATE_EUR: GATE_EUR,
    GAP_MAX_EUR: GAP_MAX_EUR,
    MIN_PRICE_EUR: MIN_PRICE_EUR,
    OFFERS: OFFERS,
    DENY: DENY,
    classifyItem: classifyItem,
    candidateHandles: candidateHandles,
    pickOffer: pickOffer,
    refresh: scheduleRefresh,
    clearProductCache: function () { productCache = {}; }
  };
})();
